import React, {useEffect, useState} from "react";
import axios from "axios";
import Swal from "sweetalert2";
import ERPDataGrid from "../ERPDataGrid";
import "../ERPTheme.css";
import {baseUrl, ipAddress, userName} from "../Univ";
function SupplierQuotation() {
    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState([]);
    const [rfqList, setRFQList] = useState([]);
    const [supplierList, setSupplierList] = useState([]);
    const [requestItems, setRequestItems] = useState([]);
    const [quotationItems, setQuotationItems] = useState([{
        id: null,
        purchase_request_item: "",
        quantity: "",
        rate: "",
        discount_percent: 0,
        gst_percent: 0,
        brand: "",
        remarks: ""
    }]);
    const [editId, setEditId] = useState(null);
    const [formData, setFormData] = useState({
        quotation_no: "",
        supplier: "",
        rfq: "",
        quotation_date: "",
        validity_date: "",
        delivery_days: "",
        payment_terms: "",
        remarks: "",
        status: "DRAFT"
    });
    // ==========================================
// QUOTATION ITEMS
// ==========================================
    const [quotationRows, setQuotationRows] = useState([{
        purchase_request_item: "", quantity: "", rate: "", discount_percent: 0, gst_percent: 0, brand: "", remarks: ""
    }]);
    const addQuotationRow = () => {
        setQuotationRows([...quotationRows, {
            purchase_request_item: "",
            quantity: "",
            rate: "",
            discount_percent: 0,
            gst_percent: 0,
            brand: "",
            remarks: ""
        }]);
    };
    const removeQuotationRow = (index) => {
        const data = [...quotationRows];
        data.splice(index, 1);
        setQuotationRows(data);
    };
    const handleQuotationChange = (index, e) => {
        const {name, value} = e.target;
        const data = [...quotationRows];
        data[index][name] = value;
        setQuotationRows(data);
    };
    useEffect(() => {
        getQuotations();
        getSuppliers();
        getRFQ();
    }, []);
    // ==========================================
    // LOAD QUOTATIONS
    // ==========================================
    const getQuotations = () => {
        setLoading(true);
        axios
            .get(baseUrl + "supplier-quotation/")
            .then((res) => {
                setRows(res.data);
                setLoading(false);
            })
            .catch(() => {
                setLoading(false);
            });
    };
    // ==========================================
    // LOAD SUPPLIERS
    // ==========================================
    const getSuppliers = () => {
        axios
            .get(baseUrl + "user-profile/")
            .then((res) => {
                const suppliers = res.data.filter(x => x.role === "FARMER");
                setSupplierList(suppliers);
            });
    };
    // ==========================================
    // LOAD RFQ
    // ==========================================
    const getRFQ = () => {
        axios
            .get(baseUrl + "rfq/")
            .then((res) => {
                setRFQList(res.data);
            });
    };
    // ==========================================
    // LOAD PURCHASE REQUEST ITEMS
    // ==========================================
    const loadPurchaseRequestItems = (rfqId) => {
        if (!rfqId) {
            setRequestItems([]);
            return;
        }
        axios
            .get(baseUrl + "purchase-request-item/?rfq=" + rfqId)
            .then((res) => {
                setRequestItems(res.data);
            });
    };
    // ==========================================
    // HEADER CHANGE
    // ==========================================
    const handleChange = (e) => {
        const {name, value} = e.target;
        setFormData({
            ...formData, [name]: value
        });
        if (name === "rfq") {
            loadPurchaseRequestItems(value);
        }
    };
    // ==========================================
    // ITEM CHANGE
    // ==========================================
    const handleItemChange = (index, e) => {
        const values = [...quotationItems];
        values[index][e.target.name] = e.target.value;
        setQuotationItems(values);
    };
    // ==========================================
    // ADD ROW
    // ==========================================
    const addItemRow = () => {
        setQuotationItems([...quotationItems, {
            id: null,
            purchase_request_item: "",
            quantity: "",
            rate: "",
            discount_percent: 0,
            gst_percent: 0,
            brand: "",
            remarks: ""
        }]);
    };
    // ==========================================
    // REMOVE ROW
    // ==========================================
    const removeItemRow = (index) => {
        const values = [...quotationItems];
        values.splice(index, 1);
        setQuotationItems(values);
    };
    // ==========================================
    // CLEAR FORM
    // ==========================================
    const clearForm = () => {
        setEditId(null);
        setFormData({
            quotation_no: "",
            supplier: "",
            rfq: "",
            quotation_date: "",
            validity_date: "",
            delivery_days: "",
            payment_terms: "",
            remarks: "",
            status: "DRAFT"
        });
        setQuotationRows([{
            purchase_request_item: "",
            quantity: "",
            rate: "",
            discount_percent: 0,
            gst_percent: 0,
            brand: "",
            remarks: ""
        }]);
    };
    // ==========================================
    // EDIT
    // ==========================================
    const editData = async (row) => {

    setEditId(row.id);

    setFormData({
        quotation_no: row.quotation_no,
        supplier: row.supplier.id,
        rfq: row.rfq.id,
        quotation_date: row.quotation_date,
        validity_date: row.validity_date,
        delivery_days: row.delivery_days,
        payment_terms: row.payment_terms,
        remarks: row.remarks,
        status: row.status
    });

    // Load Purchase Request Items for selected RFQ
    await loadPurchaseRequestItems(row.rfq.id);

    // Load quotation items
    const res = await axios.get(
        baseUrl + `supplier-quotation-item/${row.id}/`
    );

  setQuotationRows(
    res.data.map(item => ({
        id: item.id,
        purchase_request_item: item.purchase_request_item.id,
        quantity: item.quantity,
        rate: item.rate,
        discount_percent: item.discount_percent,
        gst_percent: item.gst_percent,
        brand: item.brand || "",
        remarks: item.remarks || ""
    }))
);

};
    // ==========================================
    // DELETE
    // ==========================================
    const deleteData = (id) => {
        Swal.fire({
            title: "Delete Supplier Quotation?", icon: "warning", showCancelButton: true
        }).then((result) => {
            if (result.isConfirmed) {
                axios
                    .delete(baseUrl + `update-supplier-quotation/${id}/`)
                    .then(() => {
                        Swal.fire("Deleted", "Supplier Quotation Deleted", "success");
                        getQuotations();
                    });
            }
        });
    };
    // ==========================================
    // SAVE
    // ==========================================
    const saveData = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const header = new FormData();
            header.append("quotation_no", formData.quotation_no);
            header.append("supplier", formData.supplier);
            header.append("rfq", formData.rfq);
            header.append("quotation_date", formData.quotation_date);
            header.append("validity_date", formData.validity_date);
            header.append("delivery_days", formData.delivery_days);
            header.append("payment_terms", formData.payment_terms);
            header.append("remarks", formData.remarks);
            header.append("status", formData.status);
            header.append("addedby", userName);
            header.append("ip_add", ipAddress);
            let quotationId = editId;
            if (editId === null) {
                const res = await axios.post(baseUrl + "supplier-quotation/", header);
                quotationId = res.data.id;
            } else {
                await axios.put(baseUrl + `update-supplier-quotation/${editId}/`, header);
            }
            for (const item of quotationRows) {
                const data = new FormData();
                data.append("quotation", quotationId);
                data.append("purchase_request_item", item.purchase_request_item);
                data.append("quantity", item.quantity);
                data.append("rate", item.rate);
                data.append("discount_percent", item.discount_percent);
                data.append("gst_percent", item.gst_percent);
                data.append("brand", item.brand);
                data.append("remarks", item.remarks);
                    console.log(Object.fromEntries(data.entries()));
                if (item.id) {
                    await axios.put(baseUrl + `update-supplier-quotation-item/${item.id}/`, data);
                } else {
                    await axios.post(baseUrl + "supplier-quotation-item/", data);
                }
            }
            Swal.fire("Success", editId === null ? "Supplier Quotation Saved" : "Supplier Quotation Updated", "success");
            clearForm();
            getQuotations();
        } catch (err) {
            Swal.fire("Error", "Unable to Save Supplier Quotation", "error");
        }
        setLoading(false);
    };
    // ==========================================
    // DATAGRID COLUMNS
    // ==========================================
    const columns = [{
        field: "quotation_no", headerName: "Quotation No", width: 170
    }, {
        field: "supplier_name", headerName: "Supplier", width: 220, renderCell: (params) => params.row.supplier?.name
    }, {
        field: "rfq_no", headerName: "RFQ", width: 170, renderCell: (params) => params.row.rfq?.rfq_no
    }, {
        field: "quotation_date", headerName: "Quotation Date", width: 140
    }, {
        field: "validity_date", headerName: "Validity", width: 140
    }, {
        field: "status", headerName: "Status", width: 130
    }, {
        field: "action", headerName: "Action", width: 280, sortable: false, renderCell: (params) => (<>
            <button
                className="btn btn-success btn-sm me-2"
                onClick={() => editData(params.row)}
            >
                Edit
            </button>

            <button
                className="btn btn-danger btn-sm me-2"
                onClick={() => deleteData(params.row.id)}
            >
                Delete
            </button>
            <button
                className="btn btn-primary btn-sm"
                onClick={() =>
                    window.open(
                        `/supplier-quotation-print/${params.row.id}`,
                        "_blank"
                    )
                }
            >
                Print
            </button>
        </>)
    }];
    return (<div className="container-fluid mt-3">

            <div className="card shadow">

                <div className="card-header bg-success text-white">

                    <h5 className="mb-0">
                        Supplier Quotation
                    </h5>

                </div>

                <div className="card-body">

                    <form onSubmit={saveData}>

                        <div className="row">

                            <div className="col-md-3 mb-3">

                                <label>Quotation No</label>

                                <input
                                    type="text"
                                    className="form-control"
                                    name="quotation_no"
                                    value={formData.quotation_no}
                                    onChange={handleChange}
                                    required
                                />

                            </div>

                            <div className="col-md-3 mb-3">

                                <label>Supplier</label>

                                <select
                                    className="form-control"
                                    name="supplier"
                                    value={formData.supplier}
                                    onChange={handleChange}
                                    required
                                >

                                    <option value="">
                                        Select Supplier
                                    </option>

                                    {supplierList.map((supplier) => (<option
                                        key={supplier.id}
                                        value={supplier.id}
                                    >
                                        {supplier.name}
                                    </option>))}

                                </select>

                            </div>

                            <div className="col-md-3 mb-3">

                                <label>RFQ</label>

                                <select
                                    className="form-control"
                                    name="rfq"
                                    value={formData.rfq}
                                    onChange={handleChange}
                                    required
                                >

                                    <option value="">
                                        Select RFQ
                                    </option>

                                    {rfqList.map((rfq) => (<option
                                        key={rfq.id}
                                        value={rfq.id}
                                    >
                                        {rfq.rfq_no}
                                    </option>))}

                                </select>

                            </div>

                            <div className="col-md-3 mb-3">

                                <label>Status</label>

                                <select
                                    className="form-control"
                                    name="status"
                                    value={formData.status}
                                    onChange={handleChange}
                                >

                                    <option value="DRAFT">Draft</option>

                                    <option value="PENDING">Pending</option>

                                    <option value="APPROVED">Approved</option>

                                    <option value="REJECTED">Rejected</option>

                                    <option value="CLOSED">Closed</option>

                                </select>

                            </div>

                            <div className="col-md-3 mb-3">

                                <label>Quotation Date</label>

                                <input
                                    type="date"
                                    className="form-control"
                                    name="quotation_date"
                                    value={formData.quotation_date}
                                    onChange={handleChange}
                                    required
                                />

                            </div>

                            <div className="col-md-3 mb-3">

                                <label>Validity Date</label>

                                <input
                                    type="date"
                                    className="form-control"
                                    name="validity_date"
                                    value={formData.validity_date}
                                    onChange={handleChange}
                                    required
                                />

                            </div>

                            <div className="col-md-3 mb-3">

                                <label>Delivery Days</label>

                                <input
                                    type="number"
                                    className="form-control"
                                    name="delivery_days"
                                    value={formData.delivery_days}
                                    onChange={handleChange}
                                />

                            </div>

                            <div className="col-md-3 mb-3">

                                <label>Payment Terms</label>

                                <input
                                    type="text"
                                    className="form-control"
                                    name="payment_terms"
                                    value={formData.payment_terms}
                                    onChange={handleChange}
                                />

                            </div>

                            <div className="col-md-12 mb-3">

                                <label>Remarks</label>

                                <textarea
                                    rows="3"
                                    className="form-control"
                                    name="remarks"
                                    value={formData.remarks}
                                    onChange={handleChange}
                                />

                            </div>

                            <hr className="mt-3 mb-3"/>

                            <div className="col-md-12">

                                <div className="d-flex justify-content-between align-items-center mb-3">

                                    <h5>
                                        Quotation Items
                                    </h5>

                                </div>
                                <div className="table-responsive">

                                    <table className="table-erp-modern">

                                        <thead className="table-primary">

                                        <tr>

                                            <th width="28%">Purchase Request Item</th>

                                            <th width="12%">Quantity</th>

                                            <th width="12%">Rate</th>

                                            <th width="10%">Discount %</th>

                                            <th width="10%">GST %</th>

                                            <th width="14%">Brand</th>

                                            <th width="10%">Remarks</th>

                                            <th width="4%">Action</th>

                                        </tr>

                                        </thead>

                                        <tbody>

                                        {quotationRows.map((row, index) => (<tr key={index}>

                                            <td>

                                                <select
                                                    className="form-control"
                                                    name="purchase_request_item"
                                                    value={row.purchase_request_item}
                                                    onChange={(e) => handleQuotationChange(index, e)}
                                                    required
                                                >

                                                    <option value="">
                                                        Select Item
                                                    </option>

                                                    {requestItems.map((item) => (<option
                                                        key={item.id}
                                                        value={item.id}
                                                    >
                                                        {item.item.item_name} ({item.quantity})
                                                    </option>))}

                                                </select>

                                            </td>

                                            <td>

                                                <input
                                                    type="number"
                                                    step="0.01"
                                                    className="form-control"
                                                    name="quantity"
                                                    value={row.quantity}
                                                    onChange={(e) => handleQuotationChange(index, e)}
                                                    required
                                                />

                                            </td>

                                            <td>

                                                <input
                                                    type="number"
                                                    step="0.01"
                                                    className="form-control"
                                                    name="rate"
                                                    value={row.rate}
                                                    onChange={(e) => handleQuotationChange(index, e)}
                                                    required
                                                />

                                            </td>

                                            <td>

                                                <input
                                                    type="number"
                                                    step="0.01"
                                                    className="form-control"
                                                    name="discount_percent"
                                                    value={row.discount_percent}
                                                    onChange={(e) => handleQuotationChange(index, e)}
                                                />

                                            </td>

                                            <td>

                                                <input
                                                    type="number"
                                                    step="0.01"
                                                    className="form-control"
                                                    name="gst_percent"
                                                    value={row.gst_percent}
                                                    onChange={(e) => handleQuotationChange(index, e)}
                                                />

                                            </td>

                                            <td>

                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="brand"
                                                    value={row.brand}
                                                    onChange={(e) => handleQuotationChange(index, e)}
                                                />

                                            </td>

                                            <td>

                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="remarks"
                                                    value={row.remarks}
                                                    onChange={(e) => handleQuotationChange(index, e)}
                                                />

                                            </td>

                                            <td>

                                                {quotationRows.length > 1 && (<button
                                                    type="button"
                                                    className="btn btn-danger btn-sm"
                                                    onClick={() => removeQuotationRow(index)}
                                                >
                                                    X
                                                </button>)}

                                            </td>

                                        </tr>))}

                                        </tbody>

                                    </table>

                                </div>

                                <div className="mt-2">

                                    <button
                                        type="button"
                                        className="btn btn-primary"
                                        onClick={addQuotationRow}
                                    >
                                        + Add Item
                                    </button>

                                </div>

                            </div>
                            {/* col-md-12 */}

                        </div>
                        {/* row */}

                        <div className="col-md-12 mt-4">

                            <button
                                type="submit"
                                className="btn btn-success me-2"
                                disabled={loading}
                            >
                                {editId === null ? "Save Supplier Quotation" : "Update Supplier Quotation"}
                            </button>

                            <button
                                type="button"
                                className="btn btn-secondary"
                                onClick={clearForm}
                            >
                                Clear
                            </button>

                        </div>

                    </form>

                </div>

            </div>

            <div className="card shadow mt-3">

                <div className="card-header bg-primary text-white">

                    <h5 className="mb-0">
                        Supplier Quotation List
                    </h5>

                </div>

                <div className="card-body">

                    <div style={{height: 600, width: "100%"}}>

                        <ERPDataGrid
                            rows={rows}
                            columns={columns}
                            loading={loading}
                            getRowId={(row) => row.id}
                            pageSizeOptions={[10, 25, 50, 100]}
                            initialState={{
                                pagination: {
                                    paginationModel: {
                                        pageSize: 10
                                    }
                                }
                            }}
                            disableRowSelectionOnClick
                        />

                    </div>

                </div>

            </div>

        </div>);
}
export default SupplierQuotation;